import { render, staticRenderFns } from "./addClient.vue?vue&type=template&id=40657a14&scoped=true"
import script from "./addClient.vue?vue&type=script&lang=js"
export * from "./addClient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40657a14",
  null
  
)

export default component.exports